import './globals.css'

import AppWithContent from './AppWithContent'
import { ActiveSelectFieldProvider } from './context/ActiveSelectFieldProvider'
import { TravelSearchProvider } from './context/TravelSearchProvider'
import ErrorBoundary from './ErrorBoundary'

const App = ({ hasOffer }: { hasOffer: boolean | undefined }) => {
  return (
    <ErrorBoundary>
      <TravelSearchProvider>
        <ActiveSelectFieldProvider>
          <AppWithContent hasOffer={hasOffer} />
          <div data-e2e="deployed" />
        </ActiveSelectFieldProvider>
      </TravelSearchProvider>
    </ErrorBoundary>
  )
}

export default App
